import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router';
import { Toaster } from 'sonner';
import { AppShell } from '@/components/app-shell';
import { queryClient } from '@/lib/api';
import { AgentsPage } from '@/pages/agents';
import { CalendarPage } from '@/pages/calendar';
import { DashboardPage } from '@/pages/dashboard';
import { DonePage } from '@/pages/done';
import {
  ArchivePage,
  InboxPage,
  NextActionsPage,
  QuestionsPage,
  SavedViewPage,
  SearchPage,
} from '@/pages/lists';
import { ListsOverviewPage } from '@/pages/lists-overview';
import { LoginPage } from '@/pages/login';
import { MapPage } from '@/pages/map';
import { NodePage } from '@/pages/node';
import { DailyReviewPage, WeeklyReviewPage } from '@/pages/review';
import { SettingsPage } from '@/pages/settings';
import { TodayPage } from '@/pages/today';
import './index.css';

const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  {
    element: <AppShell />,
    children: [
      { path: '/', element: <TodayPage /> },
      { path: '/today', element: <Navigate to="/" replace /> },
      { path: '/overview', element: <DashboardPage /> },
      { path: '/next', element: <NextActionsPage /> },
      { path: '/lists', element: <ListsOverviewPage /> },
      { path: '/inbox', element: <InboxPage /> },
      { path: '/calendar', element: <CalendarPage /> },
      { path: '/done', element: <DonePage /> },
      { path: '/agents', element: <AgentsPage /> },
      { path: '/questions', element: <QuestionsPage /> },
      { path: '/map', element: <MapPage /> },
      { path: '/archive', element: <ArchivePage /> },
      { path: '/search', element: <SearchPage /> },
      { path: '/settings', element: <SettingsPage /> },
      { path: '/review/daily', element: <DailyReviewPage /> },
      { path: '/review/weekly', element: <WeeklyReviewPage /> },
      { path: '/node/:id', element: <NodePage /> },
      { path: '/view/:id', element: <SavedViewPage /> },
    ],
  },
]);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <Toaster richColors position="bottom-right" toastOptions={{ style: { borderRadius: 12 } }} />
    </QueryClientProvider>
  </StrictMode>,
);
